<div class="IsochroneInfoPanel" v-if="isochroneFeature != undefined">
  
  
  <h3>Feature innerhalb der Isochrone</h3>
  <div v-if="NumFeatures">
      Keine POIS innerhalb der Isochrone.
  </div>

  <div v-else>

    {{getNumFeatures()}}

    <h3>Details:</h3>
    <CollapsibleFeaturesList :featuresList="resultset"/>

  </div>
  <hr>
</div>


  